import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const PanelContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 690px;
	max-width: 95vw;
	max-height: 90vh;
	display: flex;
	flex-direction: column;
	background-color: #111314;
	border-radius: 10px;
	overflow: visible;
	user-select: none;
	border: 1px solid rgba(255, 255, 255, 0.1);
	box-shadow: 0 0 30px rgba(0, 0, 0, 0.5);
`;

const HeaderContainer = styled.div`
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 15px 20px;
	background-color: rgba(255, 255, 255, 0.03);
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

const Title = styled(Text)`
	font-size: 18px;
	font-weight: 600;
	color: #ffffff;
`;

const ContentContainer = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	padding: 20px;
	gap: 15px;
	overflow: visible;
`;

const StyledInputGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
`;

const StyledInputLabel = styled.label`
	font-family: 'GT Walsheim Pro';
	font-size: 14px;
	color: rgba(255, 255, 255, 0.7);
`;

const StyledOptionalLabel = styled.span`
	font-family: 'GT Walsheim Pro';
	font-size: 10px;
	color: rgba(255, 255, 255, 0.35);
	margin-left: 6px;
`;

const StyledRewardCard = styled.div`
	position: relative;
	background: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	padding: 12px;
	display: flex;
	flex-direction: column;
	gap: 8px;
	overflow: visible;
`;

export {
	ContentContainer,
	HeaderContainer,
	PanelContainer,
	StyledInputGroup,
	StyledInputLabel,
	StyledOptionalLabel,
	StyledRewardCard,
	Title,
};
